"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searcher = void 0;
const minisearch_1 = __importDefault(require("minisearch"));
const searcher = (documents) => {
    if (!documents || documents.length === 0) {
        return new minisearch_1.default({
            fields: [],
            storeFields: []
        });
    }
    const miniSearch = new minisearch_1.default({
        fields: Object.getOwnPropertyNames(documents[0]),
        storeFields: Object.getOwnPropertyNames(documents[0]),
        searchOptions: {
            prefix: true,
            fuzzy: term => (term.length >= 3 ? 0.2 : false)
        }
    });
    miniSearch.addAll(documents.map((v, idx) => (Object.assign({ id: idx }, v))));
    return miniSearch;
};
exports.searcher = searcher;
